export default __webpack_public_path__ + "static/media/myresume.3d6d8bed.pdf";